import { IRegimeTributario } from "../interfaces/IRegimeTributario";
import { IRegimeTributarioEvento } from "../interfaces/IRegimeTributarioEvento";
import api from "./Api";

class RegimeTributarioService {
    async obterTodos(): Promise<IRegimeTributario[]> {
        const { data: result } = await api.get<IRegimeTributario[]>(`RegimeTributario`);

        return result;
    }

    async obterTodosByIdEmpresa(empresaID: number): Promise<IRegimeTributario[]> {
        const { data: result } = await api.get<IRegimeTributario[]>(`RegimeTributario/GetByEmpresaID/${empresaID}`);

        return result;
    }

    async obterTodosByIdEvento(eventoID: number): Promise<IRegimeTributarioEvento[]>{
        const { data: result} = await api.get<IRegimeTributarioEvento[]>(`RegimeTributario/GetByEventoID/${eventoID}`);

        return result;
    }
}


export default new RegimeTributarioService();